import Swiper from 'swiper/bundle';

const initAboutStorySlider = () => {
    const sliders = document.querySelectorAll('.js-about-story-slider');

    if (!sliders.length) {
        return;
    }

    sliders.forEach((slider) => {
        const wrapper = slider.querySelector('.swiper-wrapper');
        let slides = slider.querySelectorAll('.swiper-slide');

        if (slides.length < 2) {
            return;
        }

        if (slides.length >= 2 && slides.length < 6) {
            const timesToCopy = Math.ceil(6 / slides.length) - 1;
            for (let i = 0; i < timesToCopy; i++) {
                slides.forEach(slide => {
                    const clone = slide.cloneNode(true);
                    wrapper.appendChild(clone);
                });
            }
        }

        new Swiper(slider, {
            slidesPerView: 'auto',
            centeredSlides: true,
            spaceBetween: 30,
            speed: 800,
            grabCursor: true,
            loop: true,
            breakpoints: {
                320: {
                    spaceBetween: 16
                },
                1024: {
                    spaceBetween: 18
                }
            }
        });
    });
};

window.addEventListener('load', initAboutStorySlider);

const sliderContainer = document.querySelector('.js-banners-slider');

if (sliderContainer) {
    const slidesCount = sliderContainer.querySelectorAll('.swiper-slide').length;

    const bannersSlider = new Swiper('.js-banners-slider', {
        watchOverflow: true,
        slidesPerView: 1,
        spaceBetween: 42,
        
        loop: slidesCount > 1, 
        
        breakpoints: {
            480: {
                slidesPerView: 2,
                loop: slidesCount > 2,
            },
            768: {
                slidesPerView: 3,
                loop: slidesCount > 3,
            },
        },
        autoplay: {
            // delay: 5000,
        },
        navigation: {
            nextEl: '.js-banners-next',
            prevEl: '.js-banners-prev',
        },
    });
}

const initGameGallery = () => {
    const gallerySlider = document.querySelector('.js-game-gallery-slider');

    if (gallerySlider) {
        new Swiper(gallerySlider, {
            slidesPerView: 'auto',
            centeredSlides: true,
            spaceBetween: 30,
            speed: 800,
            grabCursor: true,
            loop: true,
            breakpoints: {
                320: {
                    spaceBetween: 16
                },
                1024: {
                    spaceBetween: 18
                }
            }
        });
    }
};

window.addEventListener('load', () => {
    initGameGallery();
});

const initHomeLocationsSlider = () => {
    const slider = document.querySelector('.js-home-locations-slider');

    if (slider) {
        new Swiper(slider, {
            slidesPerView: 1,
            spaceBetween: 1,
            speed: 600,
            grabCursor: true,
            breakpoints: {
                768: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 3,
                }
            },
        });
    }
};

window.addEventListener('load', () => {
    initHomeLocationsSlider();
});

const initHappySlider = () => {
    const slider = document.querySelector('.js-happy-slider');

    if (slider) {
        new Swiper(slider, {
            slidesPerView: 1.3,
            spaceBetween: 24,
            speed: 600,
            grabCursor: true,
            loop: true,
        });
    }
};

window.addEventListener('load', () => {
    initHappySlider();
});

let locationsSwiper;

function initLocationsSwiper() {
  if (window.innerWidth < 1200) {
    if (!locationsSwiper) {
      locationsSwiper = new Swiper('.home-locations-swiper', {
        slidesPerView: 1,
        navigation: {
            nextEl: '.js-locations-next',
            prevEl: '.js-locations-prev',
        },
        breakpoints: {
            767: {
                slidesPerView: 2,
            }
        },
      });
    }
  } else {
    if (locationsSwiper) {
      locationsSwiper.destroy(true, true);
      locationsSwiper = null;
    }
  }
}

window.addEventListener('load', initLocationsSwiper);
window.addEventListener('resize', initLocationsSwiper);